'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class; /* eslint-disable max-len */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Header = require('../../components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('../../components/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _GoogleTagManager = require('../../components/GoogleTagManager');

var _GoogleTagManager2 = _interopRequireDefault(_GoogleTagManager);

var _LaunchTagManager = require('../../components/LaunchTagManager');

var _LaunchTagManager2 = _interopRequireDefault(_LaunchTagManager);

var _VisualWebsiteOptimizer = require('../../components/VisualWebsiteOptimizer');

var _VisualWebsiteOptimizer2 = _interopRequireDefault(_VisualWebsiteOptimizer);

var _AskSid = require('../../components/AskSid');

var _AskSid2 = _interopRequireDefault(_AskSid);

var _AdyenCheckout = require('../../components/AdyenCheckout');

var _AdyenCheckout2 = _interopRequireDefault(_AdyenCheckout);

var _LoadingScreen = require('../../components/LoadingScreen');

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _painters = require('./painters');

var _painters2 = _interopRequireDefault(_painters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactRedux.connect)(function (state) {
  return { flash: state.flash, gtm: state.gtm, launch: state.launch, loading: state.loading };
}), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(App, _React$Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      window.referrer = window.location.protocol + '//' + window.location.host + this.props.location.pathname;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.config.theme === 'painters') {
        return _react2.default.createElement(_painters2.default, this.props);
      }

      var _props$config$store = this.props.config.store,
          tagManager = _props$config$store.tagManager,
          launchTagManager = _props$config$store.launchTagManager,
          icon = _props$config$store.icon;
      var _props$config$app$hea = this.props.config.app.head,
          meta = _props$config$app$hea.meta,
          link = _props$config$app$hea.link,
          script = _props$config$app$hea.script;


      var head = {
        meta: [].concat((0, _toConsumableArray3.default)(meta)),
        link: [{ rel: 'shortcut icon', href: icon }].concat((0, _toConsumableArray3.default)(link)),
        script: [].concat((0, _toConsumableArray3.default)(script))
      };

      return _react2.default.createElement(
        'div',
        null,
        tagManager === 'gtm' && _react2.default.createElement(_GoogleTagManager2.default, {
          containerId: this.props.config.googleTagManager.containerId,
          dataLayer: this.props.gtm.dataLayer
        }),
        tagManager === 'launch' && _react2.default.createElement(_LaunchTagManager2.default, {
          rawData: this.props.launch.rawData,
          launchEmbedCode: this.props.config.launchEmbedCode,
          oneTrustConsentEmbedCode: this.props.config.oneTrustConsentEmbedCode,
          oneTrustConsentDomainScript: launchTagManager.oneTrustConsentDomainScript,
          oneTrustAutoblockEmbedCode: '//cdn.cookielaw.org/consent/' + launchTagManager.oneTrustConsentDomainScript + '/OtAutoBlock.js'
        }),
        _react2.default.createElement(_VisualWebsiteOptimizer2.default, {
          options: this.props.config.store.visualWebsiteOrganizer
        }),
        _react2.default.createElement(_AdyenCheckout2.default, null),
        _react2.default.createElement(_reactHelmet2.default, (0, _extends3.default)({}, head, {
          titleTemplate: '%s - ' + this.props.config.store.siteName
        })),
        _react2.default.createElement(_Header2.default, { params: this.props.params }),
        _react2.default.createElement(_LoadingScreen2.default, { loading: this.props.loading }),
        _react2.default.createElement(
          'div',
          { className: _style2.default.appContent },
          this.props.children
        ),
        _react2.default.createElement(_AskSid2.default, { params: this.props.config.store.askSid }),
        _react2.default.createElement(_Footer2.default, { params: this.props.params })
      );
    }
  }]);
  return App;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/App/index.js
// module id = 2506
// module chunks = 0